import React, { useState, useEffect } from 'react';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import styled from 'styled-components';
import { navDelay, loaderDelay } from '@utils';
import { usePrefersReducedMotion } from '@hooks';
import { StaticImage } from 'gatsby-plugin-image';
// import { email } from '@config';

const StyledHeroSectionExterior = styled.section`
  ${({ theme }) => theme.mixins.flexCenter};
  max-width: 900px;

  .inner {
    display: grid;
    grid-template-columns: 3fr 2fr;
    grid-gap: 50px;

    @media (max-width: 768px) {
      display: block;
    }
  }
`;

const StyledHeroSection = styled.div`
  ${({ theme }) => theme.mixins.flexCenter};

  flex-direction: column;
  align-items: flex-start;
  min-height: 100vh;
  padding: 1vh;

  @media (max-width: 480px) and (min-height: 700px) {
    padding-bottom: 10vh;
  }

  h1 {
    margin: 0 0 30px 4px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: clamp(var(--fz-sm), 5vw, var(--fz-md));
    font-weight: 400;

    @media (max-width: 480px) {
      margin: 0 0 20px 2px;
    }
  }

  h3 {
    margin-top: 10px;
    color: var(--slate);
    line-height: 0.9;
  }

  p {
    margin: 20px 0 0;
    max-width: 540px;
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const StyledPic = styled.div`
  position: relative;
  max-width: 300px;

  @media (max-width: 768px) {
    margin: 50px auto 0;
    width: 70%;
  }

  &:hover,
  &:focus {
    outline: 0;

    &:after {
      top: 15px;
      left: 15px;
    }

    .img {
      filter: none;
      mix-blend-mode: normal;
      // filter: grayscale(100%) contrast(0);
      // filter: grayscale(100%) contrast(1.5);
      filter: blur(2px) contrast(1.5);
    }
  }

  .img {
    position: relative;
    // border-radius: var(--border-radius);
    mix-blend-mode: normal;
    // filter: grayscale(100%) contrast(0);
    transition: var(--transition);
  }

  &:before,
  &:after {
    content: '';
    display: block;
    position: absolute;
    width: 100%;
    height: 100%;
    // border-radius: var(--border-radius);
    transition: var(--transition);
  }

  &:before {
    top: 0;
    left: 0;
    // background-color: var(--navy);
    // mix-blend-mode: screen;
    filter: sepia(100%);
  }

  &:after {
    // border: 2px solid var(--green);
    top: 20px;
    left: 20px;
    z-index: -1;
  }

  .tooltip {
    position: relative;
    // display: inline-block;
    display: block;
  }

  /* Tooltip text */
  .tooltip .tooltiptext {
    visibility: hidden;
    text-align: center;
    top: 100%;
    padding: 5px 5px;
    position: absolute;
    bottom: 100%;
    z-index: 1;
  }

  .tooltip:hover .tooltiptext {
    visibility: visible;
  }
`;

const Hero = () => {
  const [isMounted, setIsMounted] = useState(false);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    const timeout = setTimeout(() => setIsMounted(true), navDelay);
    return () => clearTimeout(timeout);
  }, []);

  const one = <h1>Hi, I am</h1>;
  const two = <h2 className="big-heading">rafsha mazhar</h2>;
  const three = (
    <h3 className="big-heading">
      <small>i deliver value by coding solutions that matter</small>
    </h3>
  );
  const four = (
    // <>
    <p>
      I am a self-motivated, ambitious and competent software engineer, with a deep appreciation for arts and creativity, always on the look for
      opportunities to grow in my knowledge, experience and skills.
    </p>
    // </>
  );
  const five = (
    <a
      className="email-link"
      href="https://www.linkedin.com/in/rafsha-mazhar/"
      target="_blank"
      rel="noreferrer">
      Connect with me on LinkedIn!
    </a>
  );

  const items = [one, two, three, four, five];

  return (
    <StyledHeroSectionExterior>
      <StyledPic>
        
          <StaticImage
            className="img"
            src="../../images/headshot.PNG"
            width={1000}
            quality={95}
            formats={['AUTO', 'WEBP', 'AVIF']}
            alt="Headshot"
            placeholder="blurred"
          />
        
      </StyledPic>

      <StyledHeroSection>
        {prefersReducedMotion ? (
          <>
            {items.map((item, i) => (
              <div key={i}>{item}</div>
            ))}
          </>
        ) : (
          <TransitionGroup component={null}>
            {isMounted &&
              items.map((item, i) => (
                <CSSTransition key={i} classNames="fadeup" timeout={loaderDelay}>
                  <div style={{ transitionDelay: `${i + 1}00ms` }}>{item}</div>
                </CSSTransition>
              ))}
          </TransitionGroup>
        )}
      </StyledHeroSection>
    </StyledHeroSectionExterior>
  );
};

export default Hero;
